import { DatePicker as AntDatePicker, FormItemProps } from 'antd';
import { PickerProps } from 'antd/lib/date-picker/generatePicker';
import { observer } from 'mobx-react-lite';
import { FormItem } from 'src/components/Form/FormItem';
import styled from 'styled-components';

type DatePickerFieldProps = FormItemProps & {
    pickerProps: Partial<PickerProps<any>>;
};

export const DatePickerField = observer(
    ({ pickerProps, ...props }: DatePickerFieldProps) => {
        return (
            <FormItem {...props}>
                <StyledDatePicker {...pickerProps} />
            </FormItem>
        );
    },
);

const StyledDatePicker = styled(AntDatePicker)`
    height: 40px;
    padding: 8px 12px;
    border-radius: 6px;
    width: 100%;
`;
